// eslint-disable-next-line import/prefer-default-export
export function saveFutureRoute(actionContext, futureRoute) {
  actionContext.dispatch('saveFutureRoute', futureRoute);
}
